export enum ScanType {
  Asset = 'Asset',
  User = 'User',
}
